export default {
  maxWidth: '1500px',
  contentWidth: '1170px',
};
